import React, { useEffect } from "react";

import { Option, Select } from "src/base-components/Select";
import { WorkspaceSimpleRoleType } from "src/clients/taktile-api";

type Props = {
  nullable: boolean;
  workspaceName: string;
  value: Nullable<WorkspaceSimpleRoleType>;
  dataLoc: string;
  onChange: (key: Nullable<WorkspaceSimpleRoleType>) => void;
};

const roleOptions: Option[] = [
  { key: WorkspaceSimpleRoleType.ADMIN, value: "Admin" },
  { key: WorkspaceSimpleRoleType.EDITOR, value: "Editor" },
  { key: WorkspaceSimpleRoleType.VIEWER, value: "Viewer" },
  { key: WorkspaceSimpleRoleType.REVIEWER, value: "Reviewer" },
];

export const WorkspaceRoleSelect: React.FC<Props> = ({
  nullable,
  workspaceName,
  value,
  dataLoc,
  onChange,
}) => {
  useEffect(() => {
    if (!nullable && value === null) {
      onChange(WorkspaceSimpleRoleType.VIEWER);
    }
  }, [nullable, value, onChange]);

  return (
    <li className="flex items-center justify-between border-b border-gray-100 py-2">
      <span className="text-gray-800 font-inter-semibold-13px">
        {workspaceName}
      </span>
      <div className="w-32">
        {nullable ? (
          <Select
            dataLoc={dataLoc}
            options={roleOptions}
            placeholder="No Access"
            value={value ?? null}
            fullWidth
            showResetButton
            onChange={(value) =>
              onChange(value as Nullable<WorkspaceSimpleRoleType>)
            }
          />
        ) : (
          <Select
            dataLoc={dataLoc}
            options={roleOptions}
            placeholder="No Access"
            value={value ?? null}
            fullWidth
            onChange={(value) =>
              onChange(value as Nullable<WorkspaceSimpleRoleType>)
            }
          />
        )}
      </div>
    </li>
  );
};
